import React, { useRef, useContext } from "react";
import LoadingContext from "../../context/LoadingContext";

function Modal(props) {
  const loading = useContext(LoadingContext);

  const dialogRef = useRef(null);
  React.useEffect(() => {
    console.log(props);
    if (props.isOpen) {
      dialogRef.current.showModal();
    } else {
      dialogRef.current.close();
    }
  }, [props.isOpen]);
  return (
    <>
      <dialog ref={dialogRef} id="my_modal_4" className="modal">
        <div className="modal-box w-11/12 max-w-5xl">
          <h3
            className={`font-bold text-lg ${
              props.type === "warning" && "text-yellow-500"
            } ${props.type === "error" && "text-red-500"}`}
          >
            {props.type === "warning" && (
              <i class="fa-solid fa-triangle-exclamation"></i>
            )}
            {props.type === "error" && (
              <i class="fa-solid fa-circle-exclamation"></i>
            )}{" "}
            {props.title === "Save" ? "Edit" : props.title}
          </h3>
          <br />
          {/* <p className="py-4">{props.title}</p> */}
          <hr />
          {props.children}
          <div className="modal-action content-center">
            <button className="btn" onClick={props.onCloseModal}>
              Close
            </button>
            {!props.isError && (
              <button
                className="btn"
                onClick={props.onAcceptModal}
                disabled={loading}
              >
                {loading ? (
                  <span className="loading loading-spinner loading-lg align-middle"></span>
                ) : (
                  props.button
                )}
              </button>
            )}
          </div>
        </div>
      </dialog>
    </>
  );
}

export default Modal;
